import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorCpfIcon from 'components/Icons/ErrorCpfIcon';
import BaggageIcon from '../Icons/BaggageIcon';

interface Props {
  toggle(): void;
  errorType: 'cpfNotRegister' | 'innactiveAccount' | 'generalError';
  modalType?: 'team' | 'clients' | 'default';
}

const ErrorModalIndividual: React.FC<Props> = ({ toggle, errorType, modalType }) => {
  const { t } = useTranslation(['includeTeam']);

  const cpfError = errorType === 'cpfNotRegister';
  const accountError = errorType === 'innactiveAccount';
  const generalError = errorType === 'generalError';

  return (
    <>
      {cpfError && (
        <div className="no-cpf-error-modal__container">
          <div className="Nn-cpf-error-modal__icon-wrapper">
            <ErrorCpfIcon />
          </div>
          <h3 className="no-cpf-error-modal__title">
            {modalType === 'team' ? t('no_cpf_error_team_title') : t('no_cpf_error_clients_title')}
          </h3>
          <p className="no-cpf-error-modal__subtitle">
            {modalType === 'team' ? t('no_cpf_error_team_description') : t('no_cpf_error_clients_description')}
          </p>
          <div className="no-cpf-error-modal__btns">
            <button type="button" className="ok-button" onClick={toggle}>
              Fazer novo envio
            </button>
          </div>
        </div>
      )}
      {accountError && (
        <div className="success-wrapper">
          <div className="icon-wrapper">
            <BaggageIcon />
          </div>
          <span className="title-success"> {t('no_account_error')}</span>
          <span className="subtitle"> {t('no_account_error_description')}</span>
          <button type="button" className="ok-button" onClick={toggle}>
            {t('include_another')}
          </button>
        </div>
      )}
      {generalError && (
        <div className="success-wrapper">
          <div className="icon-wrapper">
            <BaggageIcon />
          </div>
          <span className="title-success"> {t('generic_error')}</span>
          <span className="subtitle"> {t('generic_error_description')}</span>
          <button type="button" className="ok-button" onClick={toggle}>
            {t('includeTeam:try_again')}
          </button>
        </div>
      )}
    </>
  );
};
export default ErrorModalIndividual;
